module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/b2581839529721aac9ead3b0a0435d9d.png";